import { render, staticRenderFns } from "./RteBullets.vue?vue&type=template&id=623d3cf1&"
import script from "./RteBullets.vue?vue&type=script&lang=js&"
export * from "./RteBullets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports